<company-member [member]="member" [editable]="editable" *ngFor="let member of members"></company-member>
<div class="none" *ngIf="!members?.length">Сотрудники отсутствуют</div>
<!--div class="buttons"><button type="button" class="btn">ДОБАВИТЬ СОТРУДНИКА</button></div-->
